module.exports = __webpack_public_path__ + "static/img/featured-photo-1.3cdb6c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backImage/album/featured-photo/featured-photo-1.jpg
// module id = u5s/
// module chunks = 43